import { render, staticRenderFns } from "./SlotCard.vue?vue&type=template&id=ebf10ef2&scoped=true"
import script from "./SlotCard.vue?vue&type=script&lang=js"
export * from "./SlotCard.vue?vue&type=script&lang=js"
import style0 from "./SlotCard.vue?vue&type=style&index=0&id=ebf10ef2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebf10ef2",
  null
  
)

export default component.exports